import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CoachProductAutomationsPage } from "src/pages/CoachProductAutomationsPage";
import { automationsQueryOptions } from "src/queries/automations";

const routeSearchSchema = z.object({
  q: z.string().optional(),
});

export const Route = createFileRoute(
  "/_auth/_coach/products/$productId/automations/_tabs/",
)({
  component: CoachProductAutomationsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  async loader({ context, params }) {
    return context.queryClient.query({
      ...automationsQueryOptions(params.productId),
      staleTime: "static",
    });
  },
});
